import { buildFullOptions } from '@adornis/data-view/client/data-view-options.js';
import { DataTable } from '@adornis/data-view/client/table/data-table.js';
import { View } from '@adornis/data-view/db/view.js';
import { AdornisFilter } from '@adornis/filter/AdornisFilter.js';
import { stateful, useState } from '@adornis/functional-lit/stateful.js';
import { format } from 'date-fns';
import { html } from 'lit';
import { Case } from '../../db/Case.js';

export const TicketOverview = stateful(() => {
  const [searchQuery, setSearchQuery] = useState('');

  const dataViewOptions = buildFullOptions({
    class: Case,
    isSortable: false,
    customColumns: [
      {
        fieldName: 'caseNumber',
        columnName: 'Ticket ID',
        columnWidth: '150px',
      },
      { fieldName: 'phoneNumber', columnName: 'Telefonnummer', columnWidth: '200px' },
      { fieldName: 'accountResolved.accountName', columnName: 'Firma', columnWidth: '200px' },
      { fieldName: 'machine', columnName: 'Dossier Nr.', columnWidth: '150px' },
      { fieldName: 'description', columnName: 'Problem' },
      {
        fieldName: 'createdOn',
        columnName: 'Erstellt am',
        columnWidth: '175px',
        renderItem: ticket => (ticket.createdOn ? format(new Date(ticket.createdOn), 'yyyy-MM-dd HH:mm') : ''),
      },
      {
        customID: '_options',
        columnWidth: '125px',
        renderItem: ticket => html`
          <a class="btn btn-primary btn-sm" href=${`/ticket/${ticket._id}`}>Go to details</a>
        `,
      },
    ],
    view: new View({
      filter: new AdornisFilter({
        sortingFields: ['createdOn'],
        sortingDirections: ['desc'],
        search: searchQuery || null,
        searchFields: [
          'caseNumber',
          'phoneNumber',
          'accountResolved.accountName',
          'accountResolved.accountNumber',
          'machine',
        ],
      }),
    }),
  });

  return html`
    <div class="card bg-base-100 m-4">
      <div class="card-body p-8">
        <div class="flex flex-row justify-between space-x-4">
          <h2 class="card-title text-2xl font-bold text-primary mb-6">Ticket Übersicht</h2>
          <div class="flex items-center justify-between">
            <label class="input input-bordered flex items-center gap-2 min-w-xl">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-4 h-4 opacity-70 flex-none"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 104.5 4.5a7.5 7.5 0 0012.15 12.15z"
                />
              </svg>
              <input
                type="text"
                class="grow"
                placeholder="Search tickets…"
                @input=${e => setSearchQuery(e.target.value)}
              />
            </label>
          </div>
        </div>
        <div>${DataTable({ options: dataViewOptions.dataViewOptions })}</div>
      </div>
    </div>
  `;
});
